// Prodotti congelati/surgelati ceduti ad altre attività (es. bar che li
// scongelano e li mettono in vetrina). Stesse regole di recipe_rules.py
// (frozen_denomination, thaw_instructions): tenerle allineate.
// Ore e giorni sono decisi dall'operatore nel piano HACCP: quelli proposti
// sono valori prudenziali modificabili, non limiti di legge.
export const FROZEN_KEYS = ["frozen", "deep_frozen"];
export const DEFAULT_THAW_HOURS = 6;
export const DEFAULT_POST_THAW_DAYS = 2;
const FROZEN_NAME_WORD = { frozen: "CONGELATO", deep_frozen: "SURGELATO" };

// Lo stato fisico del prodotto venduto congelato va indicato accanto al nome
// (Reg. UE 1169/2011, All. VI parte A, p. 1), salvo che il nome lo contenga già.
export function frozenDenomination(name, destination) {
  const clean = (name || "").trim();
  const word = FROZEN_NAME_WORD[destination];
  if (!word || /CONGELAT|SURGELAT/i.test(clean)) return clean;
  return `${clean} — ${word}`;
}

export function thawInstructions(thawHours, postThawDays) {
  const hours = Number(thawHours) || 0;
  const days = Number(postThawDays) || 0;
  if (!hours && !days) return "";
  const parts = [];
  if (hours) parts.push(`SCONGELARE IN FRIGORIFERO A 0/+4 °C PER ALMENO ${hours} ${hours === 1 ? "ORA" : "ORE"}.`);
  if (days) parts.push(`DOPO LO SCONGELAMENTO CONSERVARE A 0/+4 °C E CONSUMARE ENTRO ${days} ${days === 1 ? "GIORNO" : "GIORNI"}.`);
  parts.push("NON RICONGELARE IL PRODOTTO SCONGELATO.");
  return parts.join(" ");
}
